module.exports = __webpack_public_path__ + "static/media/sr.be27d1ae.svg";